import { Component, OnInit } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { FieldResource } from "../../core/modules/openapi";
@Component({
  selector: "app-hidden",
  imports: [ReactiveFormsModule],
  template: `
    <div [formGroup]="group">
      <input [formControlName]="field.name" type="hidden" [value]="field.value">
    </div>
  `,
  standalone: true,
  styles: []
})
export class HiddenComponent implements OnInit {
  field: FieldResource;
  group: FormGroup;
  constructor() {}
  ngOnInit() {}
}
